// https://restcountries.com/v3.1/all

import { baseSplitApi } from "./baseApi";

const basePath = 'https://countriesnow.space/api/v0.1/countries/info?returns=currency,flag,unicodeFlag,dialCode'

const countries = 'Countries'
const subDivision = '/recruitment/uk_sub_divisions'
export const countriesApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    getAllCountries: build.query({
      query: () => {
        return {
          url: `${basePath}`,
          method: 'GET'
        }
      },
      keepUnusedDataFor: 30,
      providesTags: [countries],
      transformResponse: response => response.data
    }),
    getAllSubDivisions: build.query({
      query: () => {
        return {
          url: `${subDivision}`,
          method: 'GET',
        }
      }
    }),
  }),
  overrideExisting: false,
})



export const { useGetAllCountriesQuery , useGetAllSubDivisionsQuery } = countriesApi